import { axiosInstance } from '@/rest/axios'

const createIpfApi = () => {
  return {
    getDistinctOptionExpirationPairs: () =>
      axiosInstance.get('ipf/option-expirations/distinct-pairs'),
    getOptionExpirationLookup: (symbol) =>
      axiosInstance.get(
        `ipf/option-expirations/${symbol}?include_nonstandard=false`
      ),
    getOptionLookup: (symbol, expiration, cfi, settlementStyle) =>
      axiosInstance.get(
        `ipf/options?underlying=${symbol}&expiration=${expiration}&cfi=${cfi}&settlement_style=${settlementStyle}`
      ),
    getDistinctStocks: () => axiosInstance.get('ipf/stocks'),
  }
}

const ipfApi = createIpfApi()

export { ipfApi }
